<script>
    import { onMount, getContext } from 'svelte'
    import * as L from 'leaflet'
  
    export let latlngs = []
    export let active = false
    export let lineStyle = 'solid'
    export let fitMapToLine = false

    const Styles = {
      Solid: 'solid',
      Dashed: 'dashed'
    }

    const { getMap, paddedRenderer } = getContext('map')
    const map = getMap()

    $: classes = [
      'map-polyline',
      active ? 'map-polyline--active' : '',
      lineStyle === Styles.Dashed ? 'map-polyline--dashed' : ''
    ].join(' ')

    const polyline = L.polyline(latlngs, { renderer: paddedRenderer, className: classes })

    $: polyline.setLatLngs(latlngs)
    $: polyline.setStyle({ className: classes })
    
    $: if (latlngs.length > 0 && fitMapToLine) {
        map.fitBounds(polyline.getBounds())
    }

    onMount(() => {
        map.addLayer(polyline)

        return () => {
            map.removeLayer(polyline)
        }
    })
</script>

<style>
    :global(.map-polyline) {
        stroke: var(--color-white);
        stroke-width: 4px;
        filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.6));
    }

    :global(.map-polyline--dashed) {
        stroke-dasharray: 10 10;
    }

    :global(.map-polyline--active) {
        stroke: var(--color-primary);
    }
</style>
